export default __webpack_public_path__ + "alberta-fab-send-full.15df17e0a4e573f848af.svg";